'use client';

import { useSidebarStore } from '@/app/hooks/sidebarStore';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook, faTwitter, faInstagram } from "@fortawesome/free-brands-svg-icons";
import AddContactButton from "./AddContactButton";
import AddCurriculumButton from "./AddCurriculumButton";

interface FooterClientProps {
    userId?: string | null;
}

const FooterClient: React.FC<FooterClientProps> = ({
    userId
}) => {
    const { isCollapsed } = useSidebarStore()
    return (
        <footer className={`bg-gray-100 text-center text-sm text-gray-600 p-4 transition-all duration-300 ${isCollapsed ? 'md:ml-16' : 'md:ml-64'}`}>
            {/* Top Line */}
            <div className="border-t-4 border-white"></div>
                
            {/* Footer Content */}
            <div className="container mx-auto px-5 grid 
            grid-cols-1 md:grid-cols-4 gap-8 py-10">
                {/* Logo and description */}
                <div>
                    {/* Adding logo from URL */}
                    <h2 className="text-2xl font-bold mb-4">Boas vindas!</h2>
                    <p className="text-gray-600 mb-4">
                        Faça parte do nosso catálogo! Você é artista
                        solo, banda, DJ ou qualquer outro tipo de performer? Cadastre-se e venha conosco
                        alcançar novos públicos e oportunidades!                        
                    </p>
                    <h3 className="text-transparent bg-clip-text bg-gradient-to-r from-black to-purple-500 font-extrabold text-xl mt-4">
                        Bêckas Mello Produções Artísticas
                    </h3>
                    <div className="flex mt-4 space-x-4">
                        {/* Social Media Icons */}
                        <a href="#" className="text-gray-600 hover:text-black">
                            <FontAwesomeIcon icon={faFacebook} size="lg" />
                        </a>
                        <a href="#" className="text-gray-600 hover:text-black">
                            <FontAwesomeIcon icon={faTwitter} size="lg" />
                        </a>
                        <a href="#" className="text-gray-600 hover:text-black">
                            <FontAwesomeIcon icon={faInstagram} size="lg" />
                        </a>
                    </div>
                </div>

                {/* Explore Column */}

                <div>
                    <h3 className="font-bold mb-4">Explore</h3>
                    <ul className="text-gray-700 space-y-2">
                        <li><a href="/landing" className="hover:text-nat-reggaex-dark">
                        Homepage</a></li>
                        <li><a href="/refs" className="hover:text-nat-reggaex-dark">
                        Refs</a></li>
                    </ul>
                </div>

                {/* Languages Column */}
                <div className="flex items-center space-x-6">
                    <AddContactButton 
                        userId={userId}
                    />
                </div>
                {/* Competitive Exams Column */}
                <div className="flex items-center space-x-6">
                    <AddCurriculumButton 
                        userId={userId}
                    />
                </div>
            </div>

            {/* Footer Bottom */}
            <div className="text-center text-sm py-4 text-gray-500">
                © {new Date().getFullYear()} beckasmello.com | Todos os direitos reservados —{" "}
                <a href="/privacy" className="underline">Política de Privacidade</a> ·{" "}
                <a href="/terms" className="underline">Termos de Uso</a>
            </div>
        </footer>
    );
}
export default FooterClient;